module.exports = __webpack_public_path__ + "img/熊猫匠心.b7cd1cd4.gif";